// Dải thống kê trên cây mạng lưới (Đại lý / CTV / Shop / Đơn 30 ngày / Cần xử lý). Ô bấm được là bộ lọc của cây
// (aria-pressed): ô loại = chỉ hiện loại đó + cấp trên, "Cần xử lý" = cùng bộ lọc với nút trên thanh công cụ; bấm lại
// là về Tất cả. Một hàng nhãn gọn (30/10 — bản ô to chiếm ~110px chiều cao, nhường chỗ cho cây): máy tính xuống dòng
// khi chật; điện thoại / iPad một hàng vuốt ngang, nhãn cao 44px — theo data-viewport, không theo bề rộng.

import { cn } from '@/lib/utils'

export interface NetworkStatTile {
  key: string
  label: string
  value: number
  /** Dòng nhỏ dưới số ("12 có đơn"). */
  sub?: string
  /** Ô vuông nhỏ trước nhãn (chữ tắt loại đơn vị, "!" với Cần xử lý) — `className` là lớp màu (tone-orange bg-toneBg…). */
  badge?: { short: string; className: string }
  /** Không có = ô chỉ để xem. */
  onClick?: () => void
  active?: boolean
  /** Số tô màu cảnh báo (Cần xử lý > 0). */
  warn?: boolean
}

export function NetworkStatStrip({ tiles, label = 'Thống kê mạng lưới', className }: { tiles: NetworkStatTile[]; label?: string; className?: string }) {
  return (
    <div
      role="group"
      aria-label={label}
      className={cn('flex gap-2 desktop:flex-wrap mobile:overflow-x-auto mobile:overscroll-x-contain mobile:[scrollbar-width:none]', className)}
    >
      {tiles.map((t) => {
        const body = (
          <>
            {t.badge && (
              <span aria-hidden className={cn('flex size-5 shrink-0 items-center justify-center rounded-md text-[8.5px] font-bold', t.badge.className)}>
                {t.badge.short}
              </span>
            )}
            <span className="text-[13px] text-inkSoft">{t.label}</span>
            <span className={cn('text-[15px] font-bold tabular-nums', t.warn ? 'text-warn' : 'text-ink')}>{t.value.toLocaleString('vi-VN')}</span>
            {t.sub && <span className="text-xs text-muted">· {t.sub}</span>}
          </>
        )
        const cls = cn(
          'inline-flex h-9 shrink-0 items-center gap-2 whitespace-nowrap rounded-full bg-raise pl-2 pr-3.5 mobile:h-11',
          !t.badge && 'pl-3.5',
          t.active ? 'border-[1.5px] border-accent ring-[3px] ring-accent/20' : 'border border-rule shadow-sm',
        )
        return t.onClick ? (
          <button key={t.key} type="button" onClick={t.onClick} aria-pressed={!!t.active} className={cn(cls, 'motion-state', !t.active && 'hover:border-accent/45')}>
            {body}
          </button>
        ) : (
          <div key={t.key} className={cls}>
            {body}
          </div>
        )
      })}
    </div>
  )
}
